export default __webpack_public_path__ + "static/media/27.5c08070b.png";